<common-modal
  *ngIf="isOpen"
  size="md"
  [isOpen]="isOpen"
  (isOpenChange)="handleIsOpenChange($event)"
  position="center"
>
  <ng-container header>
    <h2 class="font-bold">
      {{ 'sellPortfolioPercentageModal.title' | translate }}
    </h2>
  </ng-container>
  <ng-container body>
    <div>
      <span>
        {{ 'sellPortfolioPercentageModal.text' | translate }}
      </span>
      <common-number-input
        [label]="'sellPortfolioPercentageModal.percentage' | translate"
        [item]="percentage"
        (itemChange)="onPercentageChange($event)"
        [required]="true"
        [min]="0"
        [max]="100"
      ></common-number-input>
      <div class="flex justify-end">
        <span>{{ 'sellPortfolioPercentageModal.value' | translate }}</span>
        <span class="ml-2">{{ value | currency }}</span>
        <span class="ml-2">/ {{ maxValue | currency }}</span>
      </div>
    </div>
  </ng-container>
  <ng-container footer>
    <button (click)="onCloseClick()" class="button-white mb-2 md:mb-0">
      {{ 'global.close' | translate }}
    </button>
    <button (click)="onSellPortfolioPercentage()" class="button mb-2 md:mb-0">
      {{ 'sellPortfolioPercentageModal.apply' | translate }}
    </button>
  </ng-container>
</common-modal>
